import createModel, { prop } from '../lib/create_model';

export default createModel({
  modelName: 'CustomChannelAddressContent',
  properties: {
    customChannelId: prop(String).isRequired,
  },
});
